// Seção "Acompanhe nosso Instagram" da página inicial.
//
// Para mostrar os posts da loja: coloque as imagens dos posts em `public/instagram/`
// e liste cada um aqui, com o endereço do post. Sem posts na lista, a seção fica
// escondida no site publicado (na visualização local ela aparece com fotos de
// produtos só para mostrar o layout).
export const instagramProfile = {
  handle: "@lojaricatanto",
  url: "https://www.instagram.com/lojaricatanto/",
};

export interface InstagramPost {
  image: string; // ex.: "/instagram/post-1.webp"
  url: string; // ex.: "https://www.instagram.com/p/XXXXXXXXXXX/"
  alt: string;
}

const base = import.meta.env.BASE_URL;

export const instagramPosts: InstagramPost[] = [
  { image: `${base}instagram/post-1.webp`, url: "https://www.instagram.com/maxxbezerra/reel/DeQDtPSB1wZ/", alt: "Reel do Instagram" },
  { image: `${base}instagram/post-2.webp`, url: "https://www.instagram.com/reservamaxbezerra/reel/DeNpy8WOWyZ/", alt: "Reel do Instagram" },
  { image: `${base}instagram/post-3.webp`, url: "https://www.instagram.com/maxxbezerra/reel/DeNXOTxu7Gm/", alt: "Reel do Instagram com brincos dourados" },
  { image: `${base}instagram/post-4.webp`, url: "https://www.instagram.com/reservamaxbezerra/reel/DeNWJeAhbYB/", alt: "Reel do Instagram com anel" },
];
